import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';

const DiagramCreatorOptionTile = ({ children, classes, onClick, image }) => (
  <button className={`${classes} tile-btn card-link bg-white`} onClick={onClick}>
    {/* Extra <div> needed to prevent IE11 bug :@ */}
    <div>
      {image &&
        <div className="tile-btn__image">
          <div className="ratio-16-9">{renderHTML(image)}</div>
        </div>
      }

      {children &&
        <div className="tile-btn__inner">
          {/* Extra <div> needed to prevent IE11 bug :@ */}
          <div>
            {children}
          </div>
        </div>
      }
    </div>
  </button>
);

DiagramCreatorOptionTile.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  classes: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  image: PropTypes.string,
};

export default DiagramCreatorOptionTile;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/DiagramCreatorOptionTile.js